import React, { useMemo } from 'react';

import { AdSidebar } from 'common/api/contentful/models/AdSidebar';
import { useFromContentful } from 'common/api/contentful/utils';
import { createStyles } from 'utils/createStyle';
import ResponsiveContainer, {
    ContainerType,
} from 'components/responsive-containers/ResponsiveContainer';

export const AdSidebarComponent = () => {
    const adSidebar = useFromContentful<AdSidebar>('adSidebar');

    const styles = createStyles({
        container: {
            width: '200px',
        },
    });

    const banners = useMemo(
        () => adSidebar.content?.items.filter((it) => it.fields.adImage) || [],
        [adSidebar]
    );
    const randomBanner = useMemo(
        () =>
            banners.length > 0 ? banners[Math.trunc(Math.random() * banners.length)] : undefined,
        [banners]
    );

    return (
        <>
            {randomBanner && (
                <ResponsiveContainer For={ContainerType.desktop}>
                    <div className={styles.container}>
                        <div>
                            <img
                                src={randomBanner.fields.adImage.fields.file.url}
                                title={randomBanner.fields.adImage.fields.description}
                            />
                        </div>
                    </div>
                </ResponsiveContainer>
            )}
        </>
    );
};
